import React from "react";
import { Chip, Tooltip, Box, Typography } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import "./VersionInfo.css";

const VersionInfo = ({ variant = "footer", showIcon = true, className = "" }) => {
  const appName = process.env.REACT_APP_NAME || "ALTRISA";
  const appVersion = process.env.REACT_APP_VERSION || "2.2.0";
  const environment = process.env.REACT_APP_ENVIRONMENT || "production";
  const buildDate = new Date().toLocaleDateString('es-PE');

  const versionInfo = {
    name: appName,
    version: appVersion,
    environment: environment,
    buildDate: buildDate,
    fullVersion: `${appName} v${appVersion}`
  };

  if (variant === "footer") {
    return (
      <div className={`version-footer ${className}`}>
        <div className="version-content">
          <span className="app-name">{versionInfo.name}</span>
          <span className="version-separator">|</span>
          <span className="app-version">v{versionInfo.version}</span>
          {environment === "development" && (
            <>
              <span className="version-separator">|</span>
              <Chip 
                label="DEV" 
                size="small" 
                color="warning" 
                variant="outlined"
                className="env-chip"
              />
            </>
          )}
        </div>
      </div>
    );
  }

  if (variant === "chip") {
    return (
      <Tooltip 
        title={
          <div>
            <div><strong>{versionInfo.name}</strong></div>
            <div>Versión: {versionInfo.version}</div>
            <div>Entorno: {versionInfo.environment}</div>
            <div>Build: {versionInfo.buildDate}</div>
          </div>
        }
        arrow
      >
        <Chip
          icon={showIcon ? <InfoIcon /> : undefined}
          label={`v${versionInfo.version}`}
          size="small"
          variant="outlined"
          color="primary"
          className={`version-chip ${className}`}
        />
      </Tooltip>
    );
  }

  if (variant === "menu") {
    return (
      <Box className={`version-menu ${className}`}>
        <Typography variant="caption" color="textSecondary">
          {versionInfo.fullVersion}
        </Typography>
        {environment === "development" && (
          <Chip 
            label="DEV" 
            size="small" 
            color="warning" 
            variant="filled"
            className="env-chip-small"
          />
        )}
      </Box>
    );
  }

  if (variant === "login") {
    return (
      <div className={`version-login ${className}`}>
        <div className="version-login-content">
          <Typography variant="h6" className="app-title">
            {versionInfo.name}
          </Typography>
          <Typography variant="body2" className="app-subtitle">
            Sistema de Gestión Financiera
          </Typography>
          <div className="version-badges">
            <Chip 
              label={`Versión ${versionInfo.version}`}
              size="small"
              variant="outlined"
              color="primary"
            />
            {environment === "development" && (
              <Chip 
                label="Desarrollo"
                size="small"
                variant="filled"
                color="warning"
                className="ml-2"
              />
            )}
          </div>
        </div>
      </div>
    );
  }

  if (variant === "card") {
    return (
      <Box className={`version-card ${className}`}>
        <div className="version-card-header">
          {showIcon && <InfoIcon className="version-icon" />}
          <Typography variant="h6" className="version-title">
            Información del Sistema
          </Typography>
        </div>
        <div className="version-details">
          <div className="version-row">
            <span className="version-label">Aplicación</span>
            <span className="version-value">{versionInfo.name}</span>
          </div>
          <div className="version-row">
            <span className="version-label">Versión</span>
            <span className="version-value">{versionInfo.version}</span>
          </div>
          <div className="version-row">
            <span className="version-label">Entorno</span>
            <Chip 
              label={environment === "production" ? "Producción" : versionInfo.environment}
              size="small"
              color={environment === "development" ? "warning" : "success"}
              variant="outlined"
            />
          </div>
          <div className="version-row">
            <span className="version-label">Build</span>
            <span className="version-value">{versionInfo.buildDate}</span>
          </div>
        </div>
      </Box>
    );
  }

  // Variant por defecto (inline)
  return (
    <span className={`version-inline ${className}`}>
      {versionInfo.fullVersion}
    </span>
  );
};

export default VersionInfo;